import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[dbmScroll]'
})
export class ScrollDirective {

    @Output() public scroll = new EventEmitter<void>();

    constructor() {
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll($event) {
        if($event){
          this.scroll.emit()
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/directives/scroll-window.directive.ts